import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { routes } from './router';
import { LanguageProvider } from './shell/language-context';
import { SettingsProvider } from './shell/settings-context';
import { SessionProvider } from './shell/session-context';
import { ThemeProvider } from './shell/theme-context';
import { ToastProvider } from './shell/toast';
import { AuthGate } from './shell/auth-gate';
import { SignOutOverlay } from './shell/sign-out-progress';
import './theme/theme.css';
import './theme/motion.css';
import './shell/dash.css';
import { reloadOnStaleChunk } from './shell/reload-on-stale-chunk';

// SPA entry. The router owns all screens; ThemeProvider holds light/dark/system
// (CB-16; the pre-paint script in index.html applies it before first paint),
// LanguageProvider the en/bn choice (packages/i18n, DR-16), SettingsProvider the
// currency/money formatter, SessionProvider the authenticated admin + section
// grants, and ToastProvider the one console toast (CB-17).
const router = createBrowserRouter(routes);
const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element');

// A tab left open across a deploy reloads instead of failing on a removed chunk.
reloadOnStaleChunk();

createRoot(rootEl).render(
  <StrictMode>
    <ThemeProvider>
      <LanguageProvider>
        <SettingsProvider>
          <SessionProvider>
            <ToastProvider>
              <AuthGate>
                <RouterProvider router={router} />
              </AuthGate>
              <SignOutOverlay />
            </ToastProvider>
          </SessionProvider>
        </SettingsProvider>
      </LanguageProvider>
    </ThemeProvider>
  </StrictMode>,
);
